import Forms from 'vuesora/src/assets/js/classes/forms';
import EmailForm from 'vuesora/src/components/EmailForm.vue';
import NotificationsTable from 'vuesora/src/views/notifications/NotificationsTable.vue';
import ContentCatalogue from 'vuesora/src/views/catalogues/ContentCatalogue.vue';
import Vue from 'vue';

import 'vuesora/src/assets/js/functions/arrayfrom-polyfill';
import 'vuesora/src/assets/js/functions/navigation';
import 'vuesora/src/assets/js/functions/user-events';
import 'vuesora/src/assets/js/functions/dropdown';
import 'vuesora/src/assets/js/functions/modal'
import 'vuesora/src/assets/js/functions/accordion';
import 'vuesora/src/assets/js/functions/instructor-info';
require('es6-promise').polyfill();

const emailForm = document.getElementById('emailForm');
const notificationsTable = document.getElementById('notificationsTable');
let contentCatalogues = document.querySelectorAll('.contentCatalogue');

const triggerEvent = (el, eventType, detail) => el.dispatchEvent(new CustomEvent(eventType, { detail }));

if(contentCatalogues.length){
    Array.from(contentCatalogues).forEach(catalogue => {
        let data_keys = Object.keys(catalogue.dataset);
        let props = {};

        data_keys.forEach(key => {
            if(catalogue.dataset[key] === 'true'){
                props['$_' + key] = true;
            }
            else if(catalogue.dataset[key] === 'false'){
                props['$_' + key] = false;
            }
            else {
                if(key === 'preLoadedContent' || key === 'filterableValues' || key === 'filterTabs'){
                    props['$_' + key] = JSON.parse(catalogue.dataset[key]);
                }
                else if(key === 'includedTypes' || key === 'statuses'){
                    props['$_' + key] = catalogue.dataset[key].split(',');
                }
                else {
                    props['$_' + key] = catalogue.dataset[key];
                }
            }
        });

        new Vue({
            el: catalogue,
            render: h => h(ContentCatalogue, {
                props: props
            })
        });
    });
}

if(emailForm){
    let emailFormProps = {};
    let emailFormData = emailForm.dataset;
    let emailFormDataKeys = Object.keys(emailFormData);

    emailFormDataKeys.forEach(dataKey => {
        if(emailFormData[dataKey] === 'true'){
            emailFormProps[dataKey] = true;
        }
        else if(emailFormData[dataKey] === 'false')
            emailFormProps[dataKey] = false;
        else {
            emailFormProps[dataKey] = emailFormData[dataKey];
        }
    });

    const emailFormVueComponent = new Vue({
        el: emailForm,
        render: h => h(EmailForm, {
            props: emailFormProps
        })
    });

    emailFormVueComponent.$children[0].$on('formSuccess', () => {
        triggerEvent(document.getElementById('modalOverlay'), 'click');
    })
}

if(notificationsTable){
    const notifications = notificationsTable.dataset['notifications'];
    const notificationsEndpoint = notificationsTable.dataset['notificationsEndpoint'];
    const settingsUrl = notificationsTable.dataset['settingsUrl'];
    const notificationCount = notificationsTable.dataset['notificationCount'];

    new Vue({
        el: notificationsTable,
        render: h => h(NotificationsTable, {
            props: {
                brand: 'recordeo',
                notifications: JSON.parse(notifications),
                notificationsEndpoint: notificationsEndpoint,
                settingsUrl: settingsUrl,
                notificationCount: Number(notificationCount),
            }
        })
    });
}

document.addEventListener('DOMContentLoaded', function(){
    Forms.addInputEventListeners();
    Forms.initializeFlatpickrInputs();
    Forms.checkErrorsInModalForms();

    const formSuccessMessages = document.querySelectorAll('.form-success-message');
    const itemDescriptions = document.querySelectorAll('.item-description');

    if(itemDescriptions.length){
        Array.from(itemDescriptions).forEach(item => {

            item.addEventListener('click', event => {
                const thisItem = event.target;

                thisItem.classList.toggle('active');

                if(thisItem.classList.contains('active')){
                    thisItem.style['max-height'] = thisItem.scrollHeight + 'px';
                }
                else {
                    thisItem.style.removeProperty('max-height');
                }
            });
        });
    }

    // Remove form success messages shortly after page load
    if(formSuccessMessages.length){
        setTimeout(function(){
            Array.from(formSuccessMessages).forEach(message => {
                message.classList.add('removed');
            });
        }, 5000);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js